module.exports = __webpack_public_path__ + "tag.b7dc522621bbbeef21fe714d272cd79c.svg";